module.exports = __webpack_public_path__ + "static/media/Stoebern01.bccb7448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stoebern01.jpg
// module id = 352
// module chunks = 0